import { render } from "./App.vue?vue&type=template&id=9cca6884&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=9cca6884&lang=css"
import "./App.vue?vue&type=style&index=1&id=9cca6884&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9cca6884"

export default script